import { Component, HostListener } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { take } from 'rxjs/internal/operators/take';
import { LogoutService } from 'src/app/services/logout.service';


@Component({
  selector: 'app-unload-base',
  template: '',
})
export class UnloadBaseComponent {
  form: any;
private isLoggedOut =false;
  constructor(private baseLogoutService:LogoutService) {
    this.baseLogoutService.getUserLogOutSubscription().pipe(take(1)).subscribe({next: (data) => {
      this.isLoggedOut =true;
    }})
  }
  setFormForChecking(form: FormGroup | FormBuilder) {
    this.form = form;
  }

  @HostListener('window:beforeunload', ['$event'])
  checkforUnsavedDataBeforeUnload(event: BeforeUnloadEvent) {
    if (this.form?.dirty && !this.isLoggedOut) {
      return false;
    }
    return true;
  }
}
